// extracted by mini-css-extract-plugin
export default {"modal":"OutlineClarificationModal_modal__r7DWQ","header":"OutlineClarificationModal_header__VzuxR","badge":"OutlineClarificationModal_badge__iCWzE"};